import { useEffect, useState } from "react";
import { Grid } from '@mui/material';

import AddEditDialog from "./AddEditDialog";
import NoteField from "../fields/NoteField";
import { ExceptionStatus } from "../../gql-types.generated";
import ErrorCategoryField from "../fields/ErrorCategoryField";

interface ErrorLogResolveDetailsDialogProps {
    isOpen: boolean;
    logStatus: ExceptionStatus;
    errorCategoryId?: string;
    onCancel: () => void;
    onSave: (
        note: string,
        categoryId?: string
    ) => void;
}

const ErrorLogResolveDetailsDialog: React.FC<ErrorLogResolveDetailsDialogProps> = props => {
    const { isOpen, logStatus, errorCategoryId, onCancel, onSave } = props;
    const [isDirty, setIsDirty] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [noteContent, setNoteContent] = useState('');
    const [categoryId, setCategoryId] = useState<string | undefined>(undefined);
   
    
    useEffect(() => {
        if (!isOpen) {
            setDefaults();
        }
    }, [isOpen]);

    useEffect(() => {
        if (errorCategoryId) {
            setCategoryId(errorCategoryId);
        }
    }, [errorCategoryId]);

    const setDefaults = () => {
        setIsDirty(false);
        setSubmitted(false);
        setNoteContent('');
        setCategoryId(undefined);
    };

    const saveNote = () => {
        if (IsFormValid()) {
            setSubmitted(true);
            onSave(noteContent, categoryId);
        }
    };

    const onError = () => {
        setSubmitted(false);
    }

    const IsFormValid = () => {
        // Using a regular expression to filter HTML tags since 
        // ReactQuill sets value to <p><br></p> when text is cleared manually
        let nonHtmlNoteValue = noteContent.replace(/<(.|\n)*?>/g, '').trim();

        return isDirty && nonHtmlNoteValue.length > 0;
    }

    const onNoteChange = (newValue: string) => {
        setIsDirty(true);
        setNoteContent(newValue);
    }

    const onCategoryChange = (categoryId?: string) => {
        setIsDirty(true);
        setCategoryId(categoryId);
    };

    return (
        <AddEditDialog
            isOpen={isOpen}
            isSubmitted={submitted}
            entityName={`${logStatus === ExceptionStatus.ResolvedError ? 'Unresolve' : 'Resolve'} Details`}
            titlePrefix="Enter"
            hideTitleCloseButton={true}
            onClose={onCancel}
            onSave={saveNote}
            validate={IsFormValid}
            onError={onError}
            maxWidth='md'
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <NoteField
                        value={noteContent}
                        placeholder="Must enter a note before updating the status..."
                        disabled={false}
                        onChange={onNoteChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ErrorCategoryField
                        value={categoryId}
                        displayHelpText
                        onChange={onCategoryChange}
                    />
                </Grid>
            </Grid>
        </AddEditDialog>
    );
}

export default ErrorLogResolveDetailsDialog;